import * as React from 'react';
import {Select} from '../../../system/select';
import {BasicFormElement} from '../../../system/form';
import {Action} from '../../../system/buttons';

export default class ReferralEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  handleChange = (property) => (value) => {
    let f = {};
    f[property] = value;
    this.setState(f);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    return (
      <>
        <BasicFormElement label={'Display'}>
          <Select
            value={this.state.displayMode}
            onChange={(displayMode) => {
              if (displayMode === 'once_in_a_period') {
                this.setState({displayMode, duration: 5 * 60_000});
              } else {
                this.setState({displayMode, duration: undefined});
              }
            }}
          >
            <option value={'permanently'}>Permanently</option>
            <option value={'once_in_a_period'}>Once every …</option>
          </Select>
        </BasicFormElement>
        {this.state.displayMode === 'once_in_a_period' && (
          <BasicFormElement label={'Once every'}>
            <Select
              value={(this.state.duration / 60_000).toString()}
              onChange={(duration) =>
                this.setState({duration: parseInt(duration) * 60_000})
              }
            >
              <option value={'5'}>5 minute</option>
              <option value={'15'}>15 minutes</option>
              <option value={'20'}>20 minutes</option>
              <option value={'30'}>30 minutes</option>
            </Select>
          </BasicFormElement>
        )}

        <Action onClick={this.saveConfiguration}>Save settings</Action>
      </>
    );
  }

  saveConfiguration = () => {
    this.props.onSave({
      ...this.state,
    });
  };
}
